var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vector",
    _vm._b({}, "vector", _vm.$props, false),
    [
      _c(
        "pointy-background",
        [
          _c("cloud", {
            attrs: { x: (_vm.keyframe / 100) * (_vm.keyframe % 1610), y: 400 }
          }),
          _c("cloud", {
            attrs: {
              x: -1000 + (_vm.keyframe >> 8) * (_vm.keyframe % 1610),
              y: 900
            }
          }),
          _vm._t("default"),
          _c("cloud", { attrs: { x: -450 + (_vm.keyframe % 1060), y: 150 } }),
          _c("cloud", { attrs: { x: -900 + (_vm.keyframe % 1440), y: 700 } })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }